import { render, staticRenderFns } from "./ModalUsuariosEleicao.vue?vue&type=template&id=170a0832&scoped=true"
import script from "./ModalUsuariosEleicao.vue?vue&type=script&lang=js"
export * from "./ModalUsuariosEleicao.vue?vue&type=script&lang=js"
import style0 from "./ModalUsuariosEleicao.vue?vue&type=style&index=0&id=170a0832&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170a0832",
  null
  
)

export default component.exports